import { useOutletContext } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { projectsApi } from '../../../api/projects';
import { DataTable } from '../../../components/DataTable';
import { Project, WorkflowStateEntry } from '../../../types/projects';

/** Reuses the existing WorkflowEngine/AuditEngine data - no separate project history mechanism. */
export function ProjectApprovalsHistoryTab() {
  const { project } = useOutletContext<{ project: Project }>();
  const projectQuery = useQuery({ queryKey: ['project', project.id], queryFn: () => projectsApi.get(project.id) });

  return (
    <section className="card">
      <h2>Approvals &amp; History</h2>
      <p className="muted">Current status: <strong>{project.status}</strong></p>

      {projectQuery.data?.auditTrail && projectQuery.data.auditTrail.length > 0 ? (
        <DataTable<WorkflowStateEntry>
          rows={projectQuery.data.auditTrail}
          rowKey={(entry) => entry.id}
          columns={[
            { header: 'When', render: (entry) => new Date(entry.created_at).toLocaleString() },
            { header: 'From', render: (entry) => entry.from_state },
            { header: 'To', render: (entry) => entry.to_state },
            { header: 'Actor (user ID)', render: (entry) => entry.actor_user_id },
            { header: 'Comment', render: (entry) => entry.comment ?? '-' },
          ]}
        />
      ) : (
        <p className="muted">No workflow history yet.</p>
      )}
    </section>
  );
}
